/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const APPEAL_APPLICATION = gql`
  mutation Appeal($input: createAppealInput) {
    appeal(input: $input) {
      applicationNo
      comment
      documents {
        name
        type
        src
        fileType
        expiry
      }
    }
  }
`;
